import React from "react";
import {useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {backgroundColor, borderRadius, flexAlignCenter, m, mb, onDesktop, p, resetWidth, w100} from "@pg-design/helpers-css";
import {BrandRankingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppPath} from "@pg-mono/rp-routes";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

export const SeeInvestmentRanking = (props: {className?: string}) => {
    const target = useResponsiveLinkTarget();
    const theme = useTheme();
    return (
        <div
            className={props.className}
            css={[borderRadius(2), backgroundColor(theme.colors.success), p(3, 2, 2, 2), onDesktop(p(5, 4, 4, 4), flexAlignCenter)]}
        >
            <BrandRankingIcon css={[m(0, "auto", 4, "auto"), onDesktop(m(0, 4, 0, 0))]} size="19" wrapperSize="19" wrapperColor={theme.colors.primary} />

            <div>
                <Text css={[mb(3), onDesktop(mb(8))]} variant="headline_2" as="div" fontFamily="secondary">
                    Ranking Inwestycji
                </Text>

                <Text css={[mb(4), onDesktop(mb(8))]} variant="headline_5" as="div">
                    Zobacz najpopularniejsze inwestycje w największych miastach Polski.
                </Text>

                <Button href={rpAppPath.ranking.base} css={[w100, onDesktop(resetWidth)]} variant="filled_primary" target={target}>
                    Zobacz Ranking inwestycji
                </Button>
            </div>
        </div>
    );
};
import React from "react";
import {useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {backgroundColor, borderRadius, flexAlignCenter, m, mb, onDesktop, p, resetWidth, w100} from "@pg-design/helpers-css";
import {BrandRankingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppPath} from "@pg-mono/rp-routes";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

export const SeeInvestmentRanking = (props: {className?: string}) => {
    const target = useResponsiveLinkTarget();
    const theme = useTheme();
    return (
        <div
            className={props.className}
            css={[borderRadius(2), backgroundColor(theme.colors.success), p(3, 2, 2, 2), onDesktop(p(5, 4, 4, 4), flexAlignCenter)]}
        >
            <BrandRankingIcon css={[m(0, "auto", 4, "auto"), onDesktop(m(0, 4, 0, 0))]} size="19" wrapperSize="19" wrapperColor={theme.colors.primary} />

            <div>
                <Text css={[mb(3), onDesktop(mb(8))]} variant="headline_2" as="div" fontFamily="secondary">
                    Ranking Inwestycji
                </Text>

                <Text css={[mb(4), onDesktop(mb(8))]} variant="headline_5" as="div">
                    Zobacz najpopularniejsze inwestycje w największych miastach Polski.
                </Text>

                <Button href={rpAppPath.ranking.base} css={[w100, onDesktop(resetWidth)]} variant="filled_primary" target={target}>
                    Zobacz Ranking inwestycji
                </Button>
            </div>
        </div>
    );
};
